import { XMarkIcon } from '@/components/Icons'
import type { MeetingTransientToastState } from '@/hooks/useSharedRoomUi'

export default function MeetingTransientToast({
  toast,
  onDismiss,
}: {
  toast: MeetingTransientToastState
  onDismiss: () => void
}) {
  return (
    <div
      role="status"
      data-testid="meeting-transient-toast"
      className="pointer-events-auto fixed bottom-[calc(max(5.5rem,env(safe-area-inset-bottom)+5rem))] left-1/2 z-[60] flex w-[min(24rem,calc(100vw-2rem))] -translate-x-1/2 items-center gap-3 rounded-full bg-slate-900 px-4 py-3 text-sm font-medium text-white shadow-lg dark:bg-slate-950"
    >
      {toast.kind === 'success' ? (
        <svg className="h-5 w-5 shrink-0 text-emerald-400" viewBox="0 0 20 20" fill="currentColor" aria-hidden>
          <path
            fillRule="evenodd"
            d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z"
            clipRule="evenodd"
          />
        </svg>
      ) : null}
      <p className="min-w-0 flex-1">{toast.message}</p>
      <button
        type="button"
        onClick={onDismiss}
        aria-label="Dismiss"
        className="shrink-0 rounded-full p-1 text-white/80 transition-colors hover:bg-white/10 hover:text-white"
      >
        <XMarkIcon className="h-4 w-4" />
      </button>
    </div>
  )
}
